import { motion } from "framer-motion";
import { CheckCircle2 } from "lucide-react";
import { Reveal, SectionHeading, EASE } from "./Reveal";

const rows = [
  "Compras por volumen",
  "Atención B2B",
  "Facturación CFDI",
  "Cobertura nacional",
  "Productos originales",
  "Garantía oficial",
  "Seguimiento postventa",
  "Atención personalizada",
  "Cotizaciones rápidas",
  "Reabasto",
];

export default function Capabilities() {
  return (
    <section id="capacidades" className="relative py-24 md:py-36 bg-white" data-testid="capabilities-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid lg:grid-cols-[1fr_1.2fr] gap-16 items-start">
        <div className="lg:sticky lg:top-32">
          <SectionHeading
            num="03"
            chapter="Capacidades"
            id="capacidades"
            title={<>Todo lo que su operación <span className="text-ecamber">necesita</span></>}
            sub="Una matriz clara de capacidades comerciales y operativas, disponibles desde el primer pedido."
          />
          <Reveal delay={0.2}>
            <div className="mt-10 inline-flex items-center gap-3 rounded-full bg-ecamber/10 border border-ecamber/30 px-6 py-3">
              <CheckCircle2 size={18} className="text-ecamber" />
              <span className="text-sm font-semibold text-ecdeep">10 de 10 capacidades disponibles</span>
            </div>
          </Reveal>
        </div>

        <Reveal>
          <div className="rounded-3xl border border-ecnavy/10 overflow-hidden soft-shadow bg-white" data-testid="capabilities-table">
            <div className="grid grid-cols-[1fr_auto] items-center bg-ecnavy px-8 py-5">
              <span className="text-xs font-semibold uppercase tracking-[0.25em] text-white/80">Capacidad</span>
              <span className="text-xs font-semibold uppercase tracking-[0.25em] text-ecamber">Disponible</span>
            </div>
            {rows.map((r, i) => (
              <motion.div
                key={r}
                initial={{ opacity: 0, x: -24 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true, margin: "-40px" }}
                transition={{ duration: 0.6, delay: i * 0.05, ease: EASE }}
                className="group grid grid-cols-[1fr_auto] items-center px-8 py-5 border-t border-ecnavy/[0.07] hover:bg-ecmist transition-colors duration-300"
                data-testid={`capability-row-${i}`}
              >
                <div className="flex items-center gap-4">
                  <span className="font-display text-xs font-semibold text-ecnavy/30 w-6">{String(i + 1).padStart(2, "0")}</span>
                  <span className="text-sm md:text-base font-medium text-ecdeep">{r}</span>
                </div>
                <span className="inline-flex h-8 w-8 rounded-full bg-ecamber/15 text-ecamber items-center justify-center group-hover:bg-ecamber group-hover:text-white transition-colors duration-300">
                  <CheckCircle2 size={17} strokeWidth={2.4} />
                </span>
              </motion.div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
